import DiscordInfo from './components/discord/discord';
import TwitchInfo from './components/twitch/twitch';

import './index.css';

interface IndexProps {
	lastRaceInfo?: unknown;
	nextRaceInfo?: unknown;
}

export default function Index({ lastRaceInfo, nextRaceInfo }: IndexProps){
	return <section className='index'>
		<div className='indexBody'>
			<div className='panel'>
				<h2>Welcome to Romhack Races!</h2>
				<p>
					Romhack Races is a community that creates and races video game romhacks, primarily from the game Super Mario World. We are known for our weekly Blind Kaizo race, where a never before seen level is provided for anyone to race.
				</p>
			</div>
			<DiscordInfo />
			<TwitchInfo />
		</div>
	</section>
}